import React from 'react';
import { LogoSVG } from './Icons';

export function LoadingData() {
  return (
    <div className="w-full h-full flex items-center justify-center my-6 md:my-40">
      <div className="slide-left-right">
        <LogoSVG className="size-60 logo-amazing" />
      </div>
    </div>
  );
}
